<template>
  <div>
    <el-main style="padding: 32px; background: #fff">
      <div v-if="status == ''">
        <div v-for="(positions, index) in positionsList" :key="index">
          <div class="enterprise-line" v-if="index > 0"></div>
          <el-row>
            <el-col :span="10">
              <div>
                <div>岗位名称</div>
                <div class="posContent">{{ positions.title }}</div>
              </div></el-col
            >
            <el-col :span="10">
              <div>
                <div>薪资范围</div>
                <div class="posContent" style="display: flex">
                  <div>
                    {{ positions.min_salary }}&nbsp;-&nbsp;{{
                      positions.max_salary
                    }}&nbsp;/月
                  </div>
                </div>
              </div></el-col
            >
            <el-col :span="4">
              <div style="display: flex" v-if="positions.ifEdit">
                <el-button
                  size="small"
                  style="width: 65px"
                  @click="deleteList(positions.id)"
                  >删除
                </el-button>
                <el-button
                  size="small"
                  style="width: 65px"
                  type="primary"
                  @click="editListStation(positions, index)"
                  >编辑</el-button
                >
              </div>
            </el-col>
            <el-col :span="24">
              <div style="margin-top: 20px">
                <div>职位描述</div>
                <div class="posContent">{{ positions.content }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <el-form
        ref="posForm"
        v-if="status"
        :inline="true"
        :rules="posRules"
        :label-position="labelPosition"
        :model="getPosition"
      >
        <el-row>
          <el-col :span="9">
            <el-form-item
              label="岗位名称"
              class="test"
              size="small"
              prop="title"
            >
              <el-input
                v-model="getPosition.title"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item
              label="薪资范围"
              style="width: 300px"
              size="small"
              prop="min_salary"
            >
              <div style="display: flex">
                <el-input
                  v-model="getPosition.min_salary"
                  style="width: 120px"
                  type="number"
                  oninput="value=value.replace(/[^0-9]/g,'')"
                  placeholder="请输入"
                ></el-input>
                <div style="margin: 0 8px">-</div>
                <el-input
                  v-model="getPosition.max_salary"
                  style="width: 120px; margin-right: 8px"
                  type="number"
                  oninput="value=value.replace(/[^0-9]/g,'')"
                  placeholder="请输入"
                ></el-input
                >/月
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item style="margin-top: 32px" v-if="cancelStatus">
              <el-button
                size="small"
                style="width: 65px"
                @click="cancelStation()"
                >取消</el-button
              >
              <el-button
                size="small"
                style="width: 65px"
                type="primary"
                @click="saveStation()"
                >保存</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="职位描述" style="width: 100%" prop="content">
              <el-input
                v-model="getPosition.content"
                class="positionDescribe"
                type="textarea"
                :rows="8"
                maxlength="500"
                show-word-limit
                resize="none"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- </div> -->
      <div>
        <div
          class="enterprise-line"
          v-if="editPosition && positionsList.length != 0"
        ></div>
        <el-form
          ref="positionForm"
          :rules="rules"
          v-if="editPosition"
          :inline="true"
          :label-position="labelPosition"
          :model="positionContent"
        >
          <el-row>
            <el-col :span="9">
              <el-form-item
                label="岗位名称"
                class="test"
                size="small"
                prop="title"
              >
                <el-input
                  v-model="positionContent.title"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item
                label="薪资范围"
                style="width: 300px"
                size="small"
                prop="min_salary"
              >
                <div style="display: flex">
                  <el-input
                    style="width: 120px"
                    type="number"
                    placeholder="请输入"
                    v-model="positionContent.min_salary"
                    oninput="value=value.replace(/[^0-9]/g,'')"
                  ></el-input>
                  <div style="margin: 0 8px">-</div>
                  <el-input
                    style="width: 120px; margin-right: 8px"
                    type="number"
                    placeholder="请输入"
                    v-model="positionContent.max_salary"
                    oninput="value=value.replace(/[^0-9]/g,'')"
                  ></el-input
                  >/月
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="4" v-if="toSave">
              <el-form-item style="margin-top: 32px">
                <el-button size="small" style="width: 65px" @click="cancelAdd"
                  >取消</el-button
                >
                <el-button
                  size="small"
                  style="width: 65px"
                  type="primary"
                  @click="saveAddStation"
                  >保存</el-button
                >
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="职位描述" style="width: 100%" prop="content">
                <el-input
                  class="positionDescribe"
                  type="textarea"
                  :rows="12"
                  maxlength="500"
                  show-word-limit
                  resize="none"
                  placeholder="请输入"
                  v-model="positionContent.content"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- </div> -->
      <div style="margin-top: 20px" v-if="status == ''">
        <el-button class="addButton" @click="addPosition" v-preventReClick
          >+&nbsp;新增岗位</el-button
        >
      </div>
    </el-main>
    <!-- </el-container> -->
  </div>
</template>

<script>
import Vue from "vue";
export default {
  data() {
    const salaryValue = (rule, value, callback) => {
      if (value === "" || value === null) {
        callback(new Error("请输入完整薪资范围"));
      } else if (
        this.positionContent.max_salary === "" ||
        this.positionContent.max_salary === null
      ) {
        callback(new Error("请输入完整薪资范围"));
      } else {
        if (
          this.positionContent.min_salary &&
          this.positionContent.max_salary
        ) {
          callback();
        } else {
          callback(new Error("请输入完整薪资范围"));
        }
      }
    };
    const posSalaryValue = (rule, value, callback) => {
      if (value === "" || value === null) {
        callback(new Error("请输入完整薪资范围"));
      } else if (
        this.getPosition.max_salary === "" ||
        this.getPosition.max_salary === null
      ) {
        callback(new Error("请输入完整薪资范围"));
      } else {
        if (this.getPosition.min_salary && this.getPosition.max_salary) {
          callback();
        } else {
          callback(new Error("请输入完整薪资范围"));
        }
      }
    };
    return {
      inputBox: false,
      ifEdit: true, //拿取到的招聘岗位编辑
      editPosition: false,
      toEdit: true,
      toSave: false,
      labelPosition: "top",
      positionsList: [],
      positionContent: {
        title: "",
        min_salary: "",
        max_salary: "",
        content: "",
      },
      getPosition: {},
      positionOther: {},
      pisitionsId: "",
      status: "",
      cancelStatus: "",
      indexs: "",
      rules: {
        title: [{ required: true, message: "请输入岗位名称", trigger: "blur" }],
        min_salary: [
          {
            required: true,
            validator: salaryValue,
            message: "请输入完整的薪资范围",
            trigger: "blur",
          },
        ],
        content: [
          { required: true, message: "请输入职位描述", trigger: "blur" },
        ],
      },
      posRules: {
        title: [{ required: true, message: "请输入岗位名称", trigger: "blur" }],
        content: [
          { required: true, message: "请输入职位描述啊", trigger: "blur" },
        ],
        min_salary: [
          {
            required: true,
            validator: posSalaryValue,
            message: "请输入完整的薪资范围",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getShopRecruit();
  },
  methods: {
    //获取招聘岗位信息
    getShopRecruit() {
      var id = this.$route.query.id;
      this.$api
        .shopRecruit({
          token: localStorage.getItem("token"),
          shop_log_id: id,
        })
        .then(({ data }) => {
          this.positionsList = data.Data.map((list) => {
            list.ifEdit = true;
            list.inputBox = false;
            return list;
          });
        })
        .catch(({ error }) => {});
    },
    //编辑招聘信息
    getUpdateShopRecruit() {
      var id = this.$route.query.id;
      this.$api
        .updateShopRecruit({
          token: localStorage.getItem("token"),
          shop_log_id: id,
          title: this.positionContent.title,
          min_salary: this.positionContent.min_salary,
          max_salary: this.positionContent.max_salary,
          content: this.positionContent.content,
        })
        .then(({ data }) => {
          this.editPosition = false;
          console.log("数据", data);
          this.getShopRecruit();
        })
        .catch(({ error }) => {});
    },
    //编辑获取到的招聘信息
    editListStation(positions, index) {
      if (this.status) {
        this.$message({
          message: "请先完成当前岗位编辑",
          type: "error",
        });
      } else {
        if (this.editPosition == true) {
          this.$message({
            message: "请先完成新增岗位的信息填写",
            type: "error",
          });
        } else {
          Vue.set(this.positionsList[index], "ifEdit", false);
          Vue.set(this.positionsList[index], "inputBox", true);
          this.status = "isEdit";
          this.cancelStatus = "cancel";
          if (this.status) {
            this.indexs = index;
            this.getPosition = positions;
          }
          // this.positionOther = this.getPosition;
          console.log(this.positionsList[this.indexs]);
        }
      }
    },
    cancelStation() {
      this.status = "";
      this.cancelStatus = "";
      this.getPosition.ifEdit = true;
      this.getShopRecruit();
    },
    //招聘信息列表删除
    deleteList(deleId) {
      this.$api
        .delShopRecruit({ token: localStorage.getItem("token"), id: deleId })
        .then(({ data }) => {
          this.getShopRecruit();
        })
        .catch(({ error }) => {});
    },
    //招聘信息列表保存
    saveStation(positions, index) {
      this.positionsList[this.indexs] = this.getPosition;
      this.$refs["posForm"].validate((valid) => {
        if (valid) {
          var id = this.$route.query.id;
          this.$api
            .updateShopRecruit({
              token: localStorage.getItem("token"),
              id: this.positionsList[this.indexs].id,
              shop_log_id: id,
              title: this.positionsList[this.indexs].title,
              min_salary: this.positionsList[this.indexs].min_salary,
              max_salary: this.positionsList[this.indexs].max_salary,
              content: this.positionsList[this.indexs].content,
            })
            .then(({ data }) => {
              console.log("编辑成功", data);
              this.getShopRecruit();
              this.status = "";
            })
            .catch(({ error }) => {});
        } else {
          this.$message({
            message: "请先填写必填信息",
            type: "error",
          });
        }
      });
    },
    //新增招聘信息
    addPosition() {
      if (this.positionsList) {
        if (this.status) {
          this.editPosition = false;
          this.$message({
            message: "请先完成当前岗位编辑",
            type: "error",
          });
        } else {
          this.positionContent = {};
          this.editPosition = true;
          this.toEdit = false;
          this.toSave = true;
        }
      } else {
        this.positionContent = {};
        this.editPosition = true;
        this.toEdit = false;
        this.toSave = true;
      }
    },
    //新增招聘信息的取消
    cancelAdd() {
      this.editPosition = false;
    },
    //新增招聘信息的保存
    saveAddStation() {
      this.$refs["positionForm"].validate((valid) => {
        if (valid) {
          this.getUpdateShopRecruit();
        } else {
          this.$message({
            message: "请先填写必填信息",
            type: "error",
          });
        }
      });
    },
    //控制输入框只能输入正整数
    prevent(e) {
      var keynum = window.event ? e.keyCode : e.which; //获取键盘码
      if (keynum == 189 || keynum == 190 || keynum == 109 || keynum == 110) {
        this.$message.warning("禁止输入小数以及负数");
        e.target.value = "";
      }
    },
  },
};
</script>

<style scoped>
.posContent {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
.test {
  width: 295px;
}
textarea {
  height: 80px;
  resize: none;
}
.addButton {
  border: dashed 1px #1890ff;
  width: 140px;
  height: 50px;
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  color: #1890ff;
  background: #fff;
  border-radius: 2px;
  /* position: absolute;
  top: 20px; */
}
.enterprise-line {
  margin-left: 0;
  margin-bottom: 40px;
  width: 100%;
  height: 1px;
  background: #e9e9e9;
}
</style>



// WEBPACK FOOTER //
// src/components/enterprise/enterprisePosition.vue